import { useFindOngoingCreatorChallengeQuery } from '@modules/Dashboard/Home/modules/recommendations/CreatorChallengeRecommendationContent/queries/useCurrentCreatorChallengeQuery';
import { useDashboardExperiments } from '@modules/Dashboard/Home/hooks/useDashboardExperiments';
const CHALLENGE_DEFINITION_ID = 'chdef_pmactSdHStmKNuMP8eV8KA';
export const useChallenge = () => {
    const { findOngoingCreatorChallengeQuery } = useFindOngoingCreatorChallengeQuery();
    const { disableCreatorChallenge } = useDashboardExperiments();
    if (disableCreatorChallenge) {
        return {
            isChallengeActive: false,
            challengeDefinitionId: undefined,
        };
    }
    const progress = !findOngoingCreatorChallengeQuery?.isSuccess ||
        !findOngoingCreatorChallengeQuery?.data?.challenges?.length
        ? null
        : findOngoingCreatorChallengeQuery.data.challenges[0];
    const isActive = progress === null;
    return {
        isChallengeActive: isActive,
        challengeDefinitionId: isActive ? CHALLENGE_DEFINITION_ID : undefined,
    };
};
